import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const createSubscription: DocumentNode = gql`
  mutation createSubscription(
    $planCode: String!
    $firstName: String!
    $lastName: String!
    $currency: String!
    $email: EmailAddress!
    $accountCode: String!
    $couponCodes: [String]
    $billingInfo: BillingInfoInput!
    $billingAddress: BillingAddressInput!
    $trialEndsAt: DateTime
  ) {
    createSubscription(
      input: {
        planCode: $planCode
        couponCodes: $couponCodes
        currency: $currency
        trialEndsAt: $trialEndsAt
        account: { code: $accountCode, email: $email, billingInfo: $billingInfo, address: $billingAddress, firstName: $firstName, lastName: $lastName }
      }
    ) {
      ... on SubscriptionCreateResponse {
        currentTermEndsAt
        trialStartedAt
        trialEndsAt
        id
        uuid
        plan {
          code
          name
        }
        unitAmount
      }
      ... on SubscriptionCreateErrorNotFound {
        error {
          message
          params
          type
        }
      }
      ... on SubscriptionCreateErrorResponse {
        error {
          type
          message
          params
          transactionError {
            code
            message
            declineCode
            merchantAdvice
            transactionId
            threeDSecureActionTokenId
          }
        }
      }
    }
  }
`

export default createSubscription
